import {
  ProductColisionEnum,
  ProductHighlightednessEnum,
  ProductPlacementStageEnum,
  ProductSelectionENUM,
  ProductVisibilityENUM,
} from '../../enums/ProductEnums';
import { ProductState } from './ProductState';

export class ModuleProductState extends ProductState {
  private _selection: ProductSelectionENUM;
  private _highlightedness: ProductHighlightednessEnum;
  private _placementStage: ProductPlacementStageEnum;
  private _colision: ProductColisionEnum;

  public get selection() {
    return this._selection;
  }

  public set selection(selection: ProductSelectionENUM) {
    this._selection = selection;
  }

  public get highlightedness() {
    return this._highlightedness;
  }

  public set highlightedness(highlightedness: ProductHighlightednessEnum) {
    this._highlightedness = highlightedness;
  }

  public get placementStage() {
    return this._placementStage;
  }

  public set placementStage(placementStage: ProductPlacementStageEnum) {
    this._placementStage = placementStage;
  }

  public get colision() {
    return this._colision;
  }

  public set colision(colision: ProductColisionEnum) {
    this._colision = colision;
  }

  constructor(
    selection: ProductSelectionENUM = ProductSelectionENUM.Unselected,
    highlightedness: ProductHighlightednessEnum = ProductHighlightednessEnum.Unhighlighted,
    placementStage: ProductPlacementStageEnum = ProductPlacementStageEnum.PreAdding,
    colision: ProductColisionEnum = ProductColisionEnum.UnColided,
    visibility: ProductVisibilityENUM = ProductVisibilityENUM.Visible,
  ) {
    super(undefined, visibility);

    this._selection = selection;
    this._highlightedness = highlightedness;
    this._placementStage = placementStage;
    this._colision = colision;
  }
}
